import { TActionButtonV2 } from './actionButton';
import { TActionButtonV3 } from './actionButtonV3';
import { TMessageBubble } from './messageBubble';
import { TMessageFiles } from './messageFiles';
import { IOfferForClientSchema } from '../repositories/chats/entities/for_client/OfferForClientSchema';
import {
  IMessageListItemV1Schema,
  EType,
} from '../repositories/chats/entities/message_list_item_v1/MessageListItemV1Schema';
import { IMessagesOfferResponse } from '../repositories/chats/v1/messages/offer';
import { IMessagesResponseError } from '../repositories/chats/v2/messages';
import { EType as ETypeChatbot, IMessageSchema } from '../repositories/cian-chat-bot/entities/message/MessageSchema';

import type { IMessageAssumptionsSchema } from '../repositories/chats/entities/check_message/MessageAssumptionsSchema';

type TMessageType = EType | ETypeChatbot;

type TMessageSchema = Omit<IMessageListItemV1Schema, 'chatId' | 'userId' | 'type'> &
  Omit<IMessageSchema, 'type' | 'fromChatBot' | 'created' | 'rowVersion' | 'status'> & {
    chatId: string;
    userId: number;
    type?: TMessageType;
    fromChatBot?: boolean;
    rowVersion?: number;
    payload?: string;
  };

enum EOutcomingStatus {
  Pending = 'pending',
  Failed = 'failed',
  Fulfilled = 'fulfilled',
  Read = 'read',
}

type TOutcomingStatus = `${EOutcomingStatus}`;

type TBaseMessage = {
  created: number;
  message: string;
  htmlText?: string | null;
  byMasterAgent?: boolean | null;
  userId: number;
  actionButtons?: TActionButtonV2[];
  actionButtonsV3?: TActionButtonV3[];
  promoName?: string;
  files?: TMessageFiles;
  isRead?: boolean;
  assumptions?: IMessageAssumptionsSchema;
  offers?: IOfferForClientSchema[];
  bubbles?: TMessageBubble[];
  type?: TMessageType;
  isOutcoming: boolean;
  rowVersion?: number;
  images?: string[];
  fromCrm?: boolean;
  fromChatBot?: boolean;
  communicationId?: string;
};

type TIncomingMessage = TBaseMessage & {
  isRead: boolean;
};

type TOutcomingMessage = TBaseMessage & {
  status: TOutcomingStatus;
};

type TMessage = TIncomingMessage | TOutcomingMessage;

type TMessagesOfferResponse = IMessagesOfferResponse & {
  data: any;
};

export {
  ETypeChatbot,
  EType as EMessageType,
  IMessageAssumptionsSchema,
  IMessagesResponseError as TMessagesResponseError,
  TMessage,
  TMessageSchema,
  TMessagesOfferResponse,
  TOutcomingStatus,
  EOutcomingStatus,
};
